module.exports = __webpack_public_path__ + "img/calendar-black.21ea196c.svg";